export class VerifyMyPassword {
    password: string;
}